export mascote from "./mascote.png";



// WEBPACK FOOTER //
// ./src/components/app/home/images/index.js